import { useMemo } from 'react';
import { setAnalysisFavoriteAction } from '../../../../redux/slices/analyses';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useChartContext } from '../../ChartContext';
import { FavoriteAnalysis } from '../../../Favorite';
import {
  parseAnalysisId,
  generateScratchpadAnalysisId,
} from '../../../../redux/utils/transientAnalysis';
import useScratchpadAnalysis from '../../utils/useScratchpadAnalysis';
import { isAnalysisLoadedSelector } from '../../../../redux/selectors/analyses';

const ChartHeaderFavorite = () => {
  const dispatch = useAppDispatch();

  const {
    metadata: { analysisId, display, isFavorite },
  } = useChartContext();

  const targetAnalysisId = parseAnalysisId(analysisId);
  const { isScratchpadAnalysisLoaded } = useScratchpadAnalysis({
    analysisId: targetAnalysisId,
  });

  const isAnalysisLoadedMemoSelector = useMemo(isAnalysisLoadedSelector, []);
  const isTargetAnalysisLoaded = useAppSelector((state) =>
    isAnalysisLoadedMemoSelector(state, targetAnalysisId),
  );

  const toggleFavorite = () => {
    if (isTargetAnalysisLoaded) {
      dispatch(
        setAnalysisFavoriteAction({
          analysisId: targetAnalysisId,
          isFavorite: !isFavorite,
        }),
      );
    }

    if (isScratchpadAnalysisLoaded) {
      const scratchpadAnalysisId =
        generateScratchpadAnalysisId(targetAnalysisId);
      dispatch(
        setAnalysisFavoriteAction({
          analysisId: scratchpadAnalysisId,
          isFavorite: !isFavorite,
        }),
      );
    }
  };

  return (
    <FavoriteAnalysis
      analysisDisplay={display}
      analysisId={targetAnalysisId}
      isFavorite={isFavorite}
      onToggle={toggleFavorite}
    />
  );
};

export default ChartHeaderFavorite;
